<nb-card class="form">
  <nb-card-header>
    <h4>{{ "dialogs.cloudConnect.title" | translate }} {{ providerLabel }}</h4>
  </nb-card-header>

  <nb-card-body>
    <!-- Loading -->
    <div *ngIf="loading" class="loading-state">
      <nb-spinner status="primary" size="medium"></nb-spinner>
    </div>

    <!-- Connected state -->
    <div *ngIf="!loading && connected" class="connected-state">
      <div class="status-row">
        <nb-icon icon="checkmark-circle-2-outline" status="success"></nb-icon>
        <div>
          <p class="status-label">{{ "dialogs.cloudConnect.connectedLabel" | translate }}</p>
          <p *ngIf="accountName" class="status-name">{{ accountName }}</p>
          <p *ngIf="accountEmail" class="status-email">{{ accountEmail }}</p>
        </div>
      </div>
      <button
        nbButton
        status="danger"
        outline
        size="small"
        [nbSpinner]="connecting"
        [disabled]="connecting"
        (click)="onDisconnect()"
      >
        {{ "dialogs.cloudConnect.disconnect" | translate }}
      </button>
    </div>

    <!-- Connect state -->
    <div *ngIf="!loading && !connected" class="connect-state">
      <p class="info-text">{{ "dialogs.cloudConnect.description" | translate }}</p>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      type="button"
      nbButton
      status="danger"
      outline
      (click)="close()"
    >
      {{ "buttons.close" | translate }}
    </button>
    <button
      *ngIf="!connected && !loading"
      nbButton
      status="primary"
      [nbSpinner]="connecting"
      [disabled]="connecting"
      (click)="onConnect()"
    >
      <nb-icon icon="link-2-outline"></nb-icon>
      {{ "dialogs.cloudConnect.connectButton" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
